import React, { useState, Fragment } from 'react'
import PropTypes from 'prop-types'
import './faq14.css'

const FAQ14 = (props) => {
  const [faq1Visible, setFaq1Visible] = useState(false)
  const [faq2Visible, setFaq2Visible] = useState(false)
  const [faq3Visible, setFaq3Visible] = useState(false)
  const [faq4Visible, setFaq4Visible] = useState(false)
  const [faq5Visible, setFaq5Visible] = useState(false)
  const [faq6Visible, setFaq6Visible] = useState(false)
  const [faq7Visible, setFaq7Visible] = useState(false)
  const [faq8Visible, setFaq8Visible] = useState(false)
  const [faq9Visible, setFaq9Visible] = useState(false)
  const [faq10Visible, setFaq10Visible] = useState(false)
  const [faq11Visible, setFaq11Visible] = useState(false)
  const [faq12Visible, setFaq12Visible] = useState(false)
  const [faq13Visible, setFaq13Visible] = useState(false)
  const [faq14Visible, setFaq14Visible] = useState(false)
  return (
    <div id={props.fAQ14Id} className="faq14faq8 thq-section-padding">
      <div className="faq14-max-width thq-section-max-width">
        <div className="faq14-container10 thq-flex-column">
          <div className="faq14-section-title thq-flex-column">
            <h2 className="faq14-text10 thq-heading-2">
              {props.heading1 ?? (
                <Fragment>
                  <span className="faq14-text30">Často kladené otázky</span>
                </Fragment>
              )}
            </h2>
            <p className="faq14-text11 thq-body-large">
              {props.content1 ?? (
                <Fragment>
                  <span className="faq14-text47">
                    <span>
                      Nevíš,
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span className="faq14-text49">jak začít</span>
                    <span>
                      {' '}
                      v posilovně, jak správně cvičit nebo co jíst po tréninku?
                      Podívej se na časté dotazy a odpovědi!
                    </span>
                  </span>
                </Fragment>
              )}
            </p>
          </div>
          <div className="faq14-list thq-flex-column">
            <div className="faq14-divider10 thq-divider-horizontal"></div>
            <div className="faq14-faq1">
              <div
                onClick={() => setFaq1Visible(!faq1Visible)}
                className="faq14-trigger10"
              >
                <p className="faq14-faq1-question10 thq-body-large">
                  {props.faq1Question ?? (
                    <Fragment>
                      <span className="faq14-text39">
                        Mohu si fitness nezávazně vyzkoušet?
                      </span>
                    </Fragment>
                  )}
                </p>
                <div className="faq14-icons-container10">
                  {!faq1Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon10">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq1Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon12">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq1Visible && (
                <div className="faq14-container13">
                  <span className="faq14-text12 thq-body-small">
                    {props.text}
                  </span>
                </div>
              )}
            </div>
            <div className="faq14-divider11 thq-divider-horizontal"></div>
            <div className="faq14-faq2">
              <div
                onClick={() => setFaq2Visible(!faq2Visible)}
                className="faq14-trigger11"
              >
                <p className="faq14-faq2-question1 thq-body-large">
                  {props.faq2Question ?? (
                    <Fragment>
                      <span className="faq14-text44">
                        Je moje permanentka přenosná na jinou osobu?
                      </span>
                    </Fragment>
                  )}
                </p>
                <div className="faq14-icons-container11">
                  {!faq2Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon14">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq2Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon16">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq2Visible && (
                <div className="faq14-container16">
                  <span className="faq14-text13 thq-body-small">
                    {props.text1}
                  </span>
                </div>
              )}
            </div>
            <div className="faq14-divider12 thq-divider-horizontal"></div>
            <div className="faq14-faq3">
              <div
                onClick={() => setFaq3Visible(!faq3Visible)}
                className="faq14-trigger12"
              >
                <p className="faq14-faq2-question2 thq-body-large">
                  {props.faq3Question ?? (
                    <Fragment>
                      <span className="faq14-text35">
                        Mohu permanentku zrušit nebo pozastavit?
                      </span>
                    </Fragment>
                  )}
                </p>
                <div className="faq14-icons-container12">
                  {!faq3Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon18">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq3Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon20">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq3Visible && (
                <div className="faq14-container19">
                  <span className="faq14-text14 thq-body-small">
                    {props.text2}
                  </span>
                </div>
              )}
            </div>
            <div className="faq14-divider13 thq-divider-horizontal"></div>
            <div className="faq14-faq4">
              <div
                onClick={() => setFaq4Visible(!faq4Visible)}
                className="faq14-trigger13"
              >
                <p className="faq14-faq2-question3 thq-body-large">
                  {props.faq4Question ?? (
                    <Fragment>
                      <span className="faq14-text29">
                        Je možné zrušit moji rezervaci?
                      </span>
                    </Fragment>
                  )}
                </p>
                <div className="faq14-icons-container13">
                  {!faq4Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon22">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq4Visible && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon24">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq4Visible && (
                <div className="faq14-container22">
                  <span className="faq14-text15 thq-body-small">
                    {props.text3}
                  </span>
                </div>
              )}
            </div>
            <div className="faq14-divider14 thq-divider-horizontal"></div>
            <div className="faq14-faq5">
              <div
                onClick={() => setFaq5Visible(!faq5Visible)}
                className="faq14-trigger14"
              >
                <p className="faq14-faq1-question11 thq-body-large">
                  {props.faq5Question ?? (
                    <Fragment>
                      <span className="faq14-text33">
                        Mohu si donést vlastní tréninkové pomůcky?
                      </span>
                    </Fragment>
                  )}
                </p>
                <div className="faq14-icons-container14">
                  {faq5Visible === false && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon26">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq5Visible === true && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon28">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq5Visible === true && (
                <div className="faq14-container25">
                  <span className="faq14-text16 thq-body-small">
                    {props.text4}
                  </span>
                </div>
              )}
            </div>
            <div className="faq14-divider15 thq-divider-horizontal"></div>
            <div className="faq14-faq6">
              <div
                onClick={() => setFaq6Visible(!faq6Visible)}
                className="faq14-trigger15"
              >
                <p className="faq14-faq1-question12 thq-body-large">
                  {props.faq5Question1 ?? (
                    <Fragment>
                      <span className="faq14-text43">
                        Jaké jsou nejvíce vytížené hodiny v gymu?
                      </span>
                    </Fragment>
                  )}
                </p>
                <div className="faq14-icons-container15">
                  {faq6Visible === false && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon30">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq6Visible === true && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon32">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq6Visible === true && (
                <div className="faq14-container28">
                  <span className="faq14-text17 thq-body-small">
                    {props.text5}
                  </span>
                </div>
              )}
            </div>
            <div className="faq14-divider16 thq-divider-horizontal"></div>
            <div className="faq14-faq7">
              <div
                onClick={() => setFaq7Visible(!faq7Visible)}
                className="faq14-trigger16"
              >
                <p className="faq14-faq1-question13 thq-body-large">
                  {props.faq5Question2 ?? (
                    <Fragment>
                      <span className="faq14-text36">
                        Musím se před vstupem do fitness registrovat?
                      </span>
                    </Fragment>
                  )}
                </p>
                <div className="faq14-icons-container16">
                  {faq7Visible === false && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon34">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq7Visible === true && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon36">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq7Visible === true && (
                <div className="faq14-container31">
                  <span className="faq14-text18 thq-body-small">
                    {props.text6}
                  </span>
                </div>
              )}
            </div>
            <div className="faq14-divider17 thq-divider-horizontal"></div>
            <div className="faq14-faq8">
              <div
                onClick={() => setFaq8Visible(!faq8Visible)}
                className="faq14-trigger17"
              >
                <p className="faq14-faq1-question14 thq-body-large">
                  {props.faq5Question3 ?? (
                    <Fragment>
                      <span className="faq14-text31">
                        Můžu si do fitness přinést vlastní nápoj a jídlo?
                      </span>
                    </Fragment>
                  )}
                </p>
                <div className="faq14-icons-container17">
                  {faq8Visible === false && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon38">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq8Visible === true && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon40">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq8Visible === true && (
                <div className="faq14-container34">
                  <span className="faq14-text19 thq-body-small">
                    {props.text7}
                  </span>
                </div>
              )}
            </div>
            <div className="faq14-divider18 thq-divider-horizontal"></div>
            <div className="faq14-faq9">
              <div
                onClick={() => setFaq9Visible(!faq9Visible)}
                className="faq14-trigger18"
              >
                <p className="faq14-faq1-question15 thq-body-large">
                  {props.faq5Question4 ?? (
                    <Fragment>
                      <span className="faq14-text37">
                        Jsou v posilovně dostupné ručníky na půjčení?
                      </span>
                    </Fragment>
                  )}
                </p>
                <div className="faq14-icons-container18">
                  {faq9Visible === false && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon42">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq9Visible === true && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon44">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq9Visible === true && (
                <div className="faq14-container37">
                  <span className="faq14-text20 thq-body-small">
                    {props.text8}
                  </span>
                </div>
              )}
            </div>
            <div className="faq14-divider19 thq-divider-horizontal"></div>
            <div
              onClick={() => setFaq10Visible(!faq10Visible)}
              className="faq14-faq10"
            >
              <div className="faq14-trigger19">
                <p className="faq14-faq1-question16 thq-body-large">
                  {props.faq5Question5 ?? (
                    <Fragment>
                      <span className="faq14-text41">
                        Co dělat, když něco zapomenu v šatně?
                      </span>
                    </Fragment>
                  )}
                </p>
                <div className="faq14-icons-container19">
                  {faq10Visible === false && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon46">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq10Visible === true && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon48">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq10Visible === true && (
                <div className="faq14-container40">
                  <span className="faq14-text21 thq-body-small">
                    {props.text9}
                  </span>
                </div>
              )}
            </div>
            <div className="faq14-divider20 thq-divider-horizontal"></div>
            <div className="faq14-faq11">
              <div
                onClick={() => setFaq11Visible(!faq11Visible)}
                className="faq14-trigger20"
              >
                <p className="faq14-faq1-question17 thq-body-large">
                  {props.faq5Question6 ?? (
                    <Fragment>
                      <span className="faq14-text42">
                        Mohu si ve fitness nabít mobil?
                      </span>
                    </Fragment>
                  )}
                </p>
                <div className="faq14-icons-container20">
                  {faq11Visible === false && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon50">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq11Visible === true && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon52">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq11Visible === true && (
                <div className="faq14-container43">
                  <span className="faq14-text22 thq-body-small">
                    {props.text10}
                  </span>
                </div>
              )}
            </div>
            <div className="faq14-divider21 thq-divider-horizontal"></div>
            <div className="faq14-faq12">
              <div
                onClick={() => setFaq12Visible(!faq12Visible)}
                className="faq14-trigger21"
              >
                <p className="faq14-faq1-question18 thq-body-large">
                  {props.faq5Question7 ?? (
                    <Fragment>
                      <span className="faq14-text34">
                        Jaký je minimální věk pro návštěvu fitness centra?
                      </span>
                    </Fragment>
                  )}
                </p>
                <div className="faq14-icons-container21">
                  {faq12Visible === false && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon54">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq12Visible === true && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon56">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq12Visible === true && (
                <div className="faq14-container46">
                  <span className="faq14-text23 thq-body-small">
                    {props.text11}
                  </span>
                </div>
              )}
            </div>
            <div className="faq14-divider22 thq-divider-horizontal"></div>
            <div className="faq14-faq13">
              <div
                onClick={() => setFaq13Visible(!faq13Visible)}
                className="faq14-trigger22"
              >
                <p className="faq14-faq1-question19 thq-body-large">
                  {props.faq5Question8 ?? (
                    <Fragment>
                      <span className="faq14-text46">
                        Pořádáte soutěže nebo výzvy pro členy?
                      </span>
                    </Fragment>
                  )}
                </p>
                <div className="faq14-icons-container22">
                  {faq13Visible === false && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon58">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq13Visible === true && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon60">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq13Visible === true && (
                <div className="faq14-container49">
                  <span className="faq14-text24 thq-body-small">
                    {props.text12}
                  </span>
                </div>
              )}
            </div>
            <div className="faq14-divider23 thq-divider-horizontal"></div>
            <div className="faq14-faq14">
              <div
                onClick={() => setFaq14Visible(!faq14Visible)}
                className="faq14-trigger23"
              >
                <p className="faq14-faq1-question20 thq-body-large">
                  {props.faq5Question9 ?? (
                    <Fragment>
                      <span className="faq14-text32">
                        Máte zřízený dětský koutek?
                      </span>
                    </Fragment>
                  )}
                </p>
                <div className="faq14-icons-container23">
                  {faq14Visible === false && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon62">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq14Visible === true && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="faq14-icon64">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq14Visible === true && (
                <div className="faq14-container52">
                  <span className="faq14-text25 thq-body-small">
                    {props.text13}
                  </span>
                </div>
              )}
            </div>
            <div className="faq14-divider24 thq-divider-horizontal"></div>
          </div>
        </div>
        <div className="faq14-content1 thq-flex-column">
          <div className="faq14-content2">
            <h2 className="faq14-text26 thq-heading-2">
              {props.heading2 ?? (
                <Fragment>
                  <span className="faq14-text45">Stále máš otázku?</span>
                </Fragment>
              )}
            </h2>
            <span className="faq14-text27 thq-body-large">
              {props.content2 ?? (
                <Fragment>
                  <span className="faq14-text40">
                    Napiš nám e-mail a náš tým ti na ní odpoví!
                  </span>
                </Fragment>
              )}
            </span>
          </div>
          <a
            href="mailto:info@fitelite.cz?subject=Dotaz z webových stránek"
            className="faq14-link thq-button-filled button"
          >
            <span className="faq14-text28 thq-body-large">
              {props.action2 ?? (
                <Fragment>
                  <span className="faq14-text38">Napiš nám</span>
                </Fragment>
              )}
            </span>
          </a>
        </div>
      </div>
    </div>
  )
}

FAQ14.defaultProps = {
  text: 'Ano, klientům po registraci nabízíme 1. vstup zdarma.',
  faq4Question: undefined,
  text6:
    'Ano, na naší recepci, kde je nezbytné zaplatit jednorázovou zálohu za čip.',
  heading1: undefined,
  faq5Question3: undefined,
  faq5Question9: undefined,
  text3: 'Ano, ale pouze za podmínek uvedených v sekci rezervace.',
  text10: 'Ano, ale za odložené věci mimo skříňku neručíme.',
  faq5Question: undefined,
  faq5Question7: undefined,
  faq3Question: undefined,
  faq5Question2: undefined,
  faq5Question4: undefined,
  text12:
    'Ano, dozvíte se více na sociálních sítích nebo v informačních emailech.',
  action2: undefined,
  text13: 'Ne, v současné době nemáme tuto službu zřízenou.',
  faq1Question: undefined,
  content2: undefined,
  faq5Question5: undefined,
  faq5Question6: undefined,
  text5:
    'Standardně mezi 13. - 19. hodinou, ale doporučujeme sledovat ukazatel obsazenosti.',
  fAQ14Id: '',
  text9:
    'Vždy po zavření naší provozovny personál kontroluje šatny a v případě nálezu bezpečně uloží na recepci.',
  faq5Question1: undefined,
  text1: 'Ne, permanentka se váže pouze ke konkrétnímu klientovi.',
  faq2Question: undefined,
  text8: 'Ano, za malý poplatek si jej můžete vypůjčit na recepci.',
  text4:
    'Ano, ale pouze takového charakteru, aby nijak neomezovaly komfort ostatních klientů.',
  text2:
    'Pouze pozastavit, ale jen ze závažných úrazů a s potvrzením od lékaře.',
  heading2: undefined,
  faq5Question8: undefined,
  text11:
    'Minimální věk máme stanovený na 12 let, mladší smí pouze za doprovodu dospělého nebo s našim trenérem.',
  content1: undefined,
  text7:
    'Ano, ale nápoj pouze nealkoholický a jídlo pouze takového charakteru, aby zápach nenarušoval komfort ostatních klientů.',
}

FAQ14.propTypes = {
  text: PropTypes.string,
  faq4Question: PropTypes.element,
  text6: PropTypes.string,
  heading1: PropTypes.element,
  faq5Question3: PropTypes.element,
  faq5Question9: PropTypes.element,
  text3: PropTypes.string,
  text10: PropTypes.string,
  faq5Question: PropTypes.element,
  faq5Question7: PropTypes.element,
  faq3Question: PropTypes.element,
  faq5Question2: PropTypes.element,
  faq5Question4: PropTypes.element,
  text12: PropTypes.string,
  action2: PropTypes.element,
  text13: PropTypes.string,
  faq1Question: PropTypes.element,
  content2: PropTypes.element,
  faq5Question5: PropTypes.element,
  faq5Question6: PropTypes.element,
  text5: PropTypes.string,
  fAQ14Id: PropTypes.string,
  text9: PropTypes.string,
  faq5Question1: PropTypes.element,
  text1: PropTypes.string,
  faq2Question: PropTypes.element,
  text8: PropTypes.string,
  text4: PropTypes.string,
  text2: PropTypes.string,
  heading2: PropTypes.element,
  faq5Question8: PropTypes.element,
  text11: PropTypes.string,
  content1: PropTypes.element,
  text7: PropTypes.string,
}

export default FAQ14
